import { render, staticRenderFns } from "./MessageOperationsBottomSheet.vue?vue&type=template&id=1074f1a8&"
import script from "./MessageOperationsBottomSheet.vue?vue&type=script&lang=js&"
export * from "./MessageOperationsBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./MessageOperationsBottomSheet.vue?vue&type=style&index=0&id=1074f1a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFadeTransition,VIcon})
